import type { ActivityFeedItem } from '@ayocore/activity/server/repositories/ActivityThreadRepository';
import { getActivityEntityTypeLabel } from '@ayocore/activity/client/extensions';
import { isActivityCommentEvent } from '@ayocore/activity/common/activity/event-registry';

export function formatFeedListDate(value?: Date | string | null): string {
  if (!value) return '—';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '—';

  const now = new Date();
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const eventDayStart = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const diffDays = Math.floor(
    (todayStart.getTime() - eventDayStart.getTime()) / (24 * 60 * 60 * 1000)
  );

  if (diffDays === 0) {
    return date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  }
  if (diffDays === 1) return 'Вчера';
  if (diffDays === 2) return 'Позавчера';

  return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: '2-digit' });
}

export function getThreadTitle(item: ActivityFeedItem): string {
  const label = item.entity_label?.trim();
  if (label) return label;
  const shortUuid = item.entity_uuid.slice(0, 8);
  return `${getActivityEntityTypeLabel(item.entity_type)} #${shortUuid}`;
}

export function getLastEventPreview(item: ActivityFeedItem): string | null {
  const fromComment =
    typeof item.last_event_comment_content === 'string'
      ? item.last_event_comment_content.trim()
      : '';
  return fromComment || null;
}

export function getLastEventText(
  item: ActivityFeedItem,
  lastEventPreview: string | null
): string | null {
  const eventType = item.last_event_type ?? '';
  const payload = item.last_event_payload;

  if (isActivityCommentEvent(eventType) && lastEventPreview) {
    return null;
  }

  // Display text формируется хендлером и хранится в payload.system_text
  if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
    const systemText = (payload as Record<string, unknown>).system_text;
    if (typeof systemText === 'string' && systemText.trim().length > 0) {
      return systemText;
    }
  }

  return null;
}

export function formatUnreadCount(unreadCount: number): string {
  if (unreadCount > 99) return '99+';
  return String(unreadCount);
}

export function buildReplyPreview(content: string, maxLength: number = 120): string {
  const normalized = content.replace(/\s+/g, ' ').trim();
  if (!normalized) return '...';
  if (normalized.length <= maxLength) return normalized;
  return `${normalized.slice(0, maxLength).trimEnd()}…`;
}
